import { Component, ViewEncapsulation, OnInit, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs/Rx';
import { timer as staticTimer } from 'rxjs/Observable/timer';

@Component({
  selector: 'toolbox-typing',
  templateUrl: './typing.component.html',
  styleUrls: ['./typing.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class typingComponent implements OnInit, OnDestroy {

  phrases = [
    "Angulex",
    "Angular par l'exemple"
  ]

  title: string;
  tabIndex: number = 0;
  switch: boolean = true;

  sub: Subscription;

  constructor() { }

  ngOnInit() {
    this.title = "";
    this.startTimer();
  }

  private startTimer = () => {

    let timer = Observable.timer(1, 250);
    this.sub = timer.subscribe(
      t => {
        if (this.switch) {
          this.changeTitle();
        }
      }
    );

  }

  changeTitle = () => {

    let l: number;
    if (this.title === this.phrases[this.tabIndex]) {
      this.switch = false;
      this.delay(2000).then( () => {
        this.switch = true;
        this.tabIndex = (this.tabIndex === 0 ? 1 : 0);
        l = 0;
        this.title = "";
      })
    } else {
      l = (this.title === "" ? 1 : this.title.length + 1);
      this.title = this.phrases[this.tabIndex].substr(0, l);
    }

  }

  delay = (ms: number) => {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }


}


// WEBPACK FOOTER //
// C:/dev/Perso/urmeo/src/app/toolbox/typing/typing.component.ts